import React from 'react';
import { connect } from 'react-redux';
import yn from 'yn';
import getTimeRemaining from '../../../../../Helpers/TwentyFourHourCountDown';
import timeSinceFormat from '../../../../../Helpers/TimeSinceFormat';
import ChatMore from './ChatMore';
import GoogleReviewRating from '../../../../../../../../Layout/chat/components/GoogleReviewRating';
import getAvatarColor from '../../../../../../../../../utils/getAvatarColor';

const InboxChatListItem = ({
  hoverMsg,
  setHoverMsg,
  msg,
  idx,
  setSelectedClient,
  selectedChat,
  setSelectedChat,
  setChatIconColor,
  associateId,
  type,
  setChatMoreRefresh,
  updateUnreadInInboxes,
  setAssignPopup,
  setHoverAssignId,
  setFollowers,
  setClientOnAssignPopup,
  role,
  setUnreadMsgMatching,
  auth,
}) => {
  const stopEventBubbling = (obj, event, color) => {
    event.preventDefault();
    setHoverMsg(obj.id);
    if (event.target.id === '' && obj) {
      const client = { ...obj, ...obj.client, client_id: obj.client.id, chat_id: obj.id, store_id: obj.storeId };
      setSelectedClient(client, event);
      setSelectedChat(obj.id);
      setChatIconColor(color);
      setUnreadMsgMatching({ chatId: obj.id, inbox: type });
    }
  };

  let id = 0;
  // eslint-disable-next-line no-return-assign, no-plusplus, no-sequences
  const uid = (() => ((id = 0), () => id++))();

  return (
    <li
      id={selectedChat === msg?.id ? `chatListSelect${uid()}` : `chatListUnselected${uid()}`}
      key={`${msg.id}chat_id${Math.floor(Math.random() * 1000)}`}
      style={{
        borderBottom: '0.5px solid #f0f0f0',
      }}
      className={`default-cursor inboxAvatarLI ${selectedChat === msg?.id ? 'chatListSelect' : ''}`}
      onClick={e => stopEventBubbling(msg, e, '#EBEBEB')}
      onKeyDown={e => stopEventBubbling(msg, e, '#EBEBEB')}
      onMouseEnter={() => setHoverMsg(msg.id)}
      onMouseLeave={() => setHoverMsg('')}
    >
      <UnreadIndicator msg={msg} decluttered={yn(auth.merchantConfig.DECLUTTERED_INBOX)} />
      <UserIconImage msg={msg} idx={idx} selected={selectedChat === msg?.id} />
      <SmallMessage msg={msg} idx={idx} />
      <ChatMoreOrDate
        msg={msg}
        hoverMsg={hoverMsg}
        associateId={associateId}
        type={type}
        chat={hoverMsg === msg.id ? msg : null}
        setChatMoreRefresh={setChatMoreRefresh}
        selectedChat={selectedChat}
        updateUnreadInInboxes={updateUnreadInInboxes}
        setAssignPopup={setAssignPopup}
        setHoverAssignId={setHoverAssignId}
        setFollowers={setFollowers}
        setClientOnAssignPopup={setClientOnAssignPopup}
        role={role}
        decluttered={yn(auth.merchantConfig.DECLUTTERED_INBOX)}
      />
    </li>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(InboxChatListItem);

const ChatMoreOrDate = ({
  msg,
  hoverMsg,
  associateId,
  type,
  chat,
  setChatMoreRefresh,
  selectedChat,
  updateUnreadInInboxes,
  setAssignPopup,
  setHoverAssignId,
  setFollowers,
  setClientOnAssignPopup,
  role,
  decluttered,
}) => {
  const inboxTime = msg => {
    if (msg?.client?.preferredContactType === 'WHATSAPP') {
      if (getTimeRemaining(msg.whatsappReceivedDateTime)) {
        return <span className="green">{getTimeRemaining(msg.whatsappReceivedDateTime)}</span>;
      }
      return <span className="missing-data-red">{timeSinceFormat(msg.lastSentTimestamp)}</span>;
    }
    return timeSinceFormat(msg.lastSentTimestamp);
  };

  const showClosedStatus = decluttered && !msg?.isOpen;

  if (hoverMsg === msg.id || selectedChat === msg?.id) {
    return (
      <div
        key={`chatMoreOrDate_chatMore_${msg.id}`}
        className="add-edit-wrap m-top-10"
        style={{ justifyContent: 'flex-end' }}
      >
        <ChatMore
          msg={msg}
          associateId={associateId}
          type={type}
          chat={chat}
          id="chat-more"
          setChatMoreRefresh={setChatMoreRefresh}
          updateUnreadInInboxes={updateUnreadInInboxes}
          setAssignPopup={setAssignPopup}
          setHoverAssignId={setHoverAssignId}
          setFollowers={setFollowers}
          setClientOnAssignPopup={setClientOnAssignPopup}
          role={role}
        />
      </div>
    );
  }
  return (
    <div
      key={`chatMoreOrDate_time_${msg.id}`}
      className="chat-status-time-container"
    >
      {showClosedStatus && <span className="chat-status-closed">Closed</span>}
      {msg.disabled || <span className="chat-time-label">{inboxTime(msg)}</span>}
    </div>
  );
};

const SmallMessage = ({ msg, idx }) => {
  const msgTrim = msg => {
    if (msg && msg.length > 16) {
      return `${msg.substr(0, 16)}...`;
    }
    return msg;
  };
  return (
    <div
      key={`smallmsg_${msg.id}`}
      className="no-text-wrap flex-col-left-center align-left"
      style={{ minWidth: 0 }}
    >
      <div className="flex-row-nospacebetween-center">
        <span className="fs-12 fw-400">{msgTrim(msg?.client?.name)}</span>
        {msg?.client?.preferredContactType === 'WHATSAPP' ? (
          <img
            alt="whatsapp icon"
            className="m-left-4"
            style={{ marginBottom: '3px' }}
            src="https://dashboard-v2-images.s3.amazonaws.com/whatsapp.svg"
          />
        ) : null}
      </div>
      {!(msg?.client?.assignedAssociates?.length > 0) && msg?.client.type === 'C ' && (
        <span className="fs-10 fw-400 mid-gray italic">Unassigned</span>
      )}
      {msg?.type === 'G' && <GoogleReviewRating rating={msg.rating} />}
      {msg.disabled || <span className="fs-10 fw-400 gray">{msgTrim(msg.lastMessage)}</span>}
    </div>
  );
};

const UnreadIndicator = ({ msg, decluttered }) => {
  // Red (unviewed failed SMS) supersedes blue (unread) — only one dot ever shows.
  // #dc3545 matches the existing "Delivery Failed" red used in the open thread
  // (see Layout/chat/Helpers/msgListFormatter.js / SentMessages.js).
  // Closed chats never show red; an unread reply there still shows blue.
  const showError = msg.isUnreadError && !(decluttered && !msg.isOpen);
  const dotColor = showError ? '#dc3545' : '#3AA4FC';
  const showDot = showError || msg.isUnread;
  return (
    <div
      key={`unread_indicator_${msg.id}`}
      className="flex-row-center-center"
      style={{ width: '18px', justifyContent: 'center' }}
    >
      <div
        style={{
          backgroundColor: dotColor,
          height: '8px',
          width: '8px',
          borderRadius: '50%',
          visibility: showDot ? 'visible' : 'hidden',
        }}
      />
    </div>
  );
};

const UserIconImage = ({ msg, idx, selected }) => {
  const initialFunc = name => {
    const initials = `${name}`
      .split(' ')
      .map(e => e.charAt(0))
      .slice(0, 2)
      .join('');
    return initials;
  };

  if (msg?.type === 'F') {
    return <img alt="Avatar" className="inboxAvatar" src="https://dashboard-v2-images.s3.amazonaws.com/facebook.svg" />;
  }
  if (msg?.type === 'I') {
    return (
      <img
        alt="Avatar"
        className="inboxAvatar"
        src="https://dashboard-v2-images.s3.amazonaws.com/instagram_logo_chat.png"
      />
    );
  }
  if (msg?.type === 'G') {
    return <img alt="avatar" className="inboxAvatar" src="https://dashboard-v2-images.s3.amazonaws.com/google.svg" />;
  }
  if (msg?.client?.image) {
    return <img alt="avatar" className="inboxAvatar" src={msg?.client?.image} />;
  }

  const avatarColor = getAvatarColor(msg?.client?.name);

  return (
    <div
      style={{
        background: avatarColor.bg,
        color: '#FFF',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
      className="inboxAvatarInitials"
    >
      <span className="no-text-wrap fs-14">{initialFunc(msg?.client?.name)}</span>
    </div>
  );
};
